import { Box, BoxProps } from '@mantine/core';
import React from 'react';

import { UpgradeRibbonRight } from '../../assets';
import {
  UpgradeTierHoverCard,
  UpgradeTierHoverCardProps,
} from './UpgradeTierHoverCard';

export interface UpgradeTierRibbonProps extends UpgradeTierHoverCardProps {
  boxProps: Partial<BoxProps>;
}

export function UpgradeTierRightRibbon({
  boxProps,
  ...upgradeTierHoverCardProps
}: UpgradeTierRibbonProps) {
  return (
    <UpgradeTierHoverCard {...upgradeTierHoverCardProps}>
      <Box {...boxProps}>
        <UpgradeRibbonRight />
      </Box>
    </UpgradeTierHoverCard>
  );
}
